import React from 'react';
import XpertLogo from '../components/XpertLogo';
import { Bug, Smartphone, Calculator, Map } from 'lucide-react';

// 1024 x 500 Google Play feature graphic.
// Open at /play-assets and screenshot with a 1024x500 viewport for the Play Console upload.
export default function FeatureGraphic() {
  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-8">
      <div className="space-y-6">
        <div
          id="feature-graphic"
          className="relative overflow-hidden text-white shadow-2xl"
          style={{ width: 1024, height: 500, background: 'linear-gradient(135deg, #0d2818 0%, #6FA82C 55%, #8BC53F 100%)' }}
        >
          <div className="absolute inset-0" style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px)', backgroundSize: '24px 24px' }}/>
          <div className="absolute -right-32 -top-32 w-[600px] h-[600px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(245,158,11,0.35) 0%, transparent 60%)' }}/>

          <div className="relative h-full flex items-center px-16 gap-12">
            <div className="w-44 h-44 rounded-3xl bg-white shadow-2xl flex items-center justify-center p-3">
              <XpertLogo size={160} variant="seal"/>
            </div>
            <div className="flex-1">
              <div className="inline-block px-3 py-1 rounded-full bg-[#F59E0B] text-[#0d2818] text-xs font-extrabold tracking-widest mb-3">XP-PRO · FIELD SERVICE PLATFORM</div>
              <h1 className="text-6xl font-extrabold tracking-tight leading-[1.05]">Real Results,<br/><span className="italic text-[#F59E0B]">Forget the Rest!</span></h1>
              <p className="mt-4 text-xl text-white/90 font-medium">Schedule · GPS · Forms · Accounting · Customer Portal</p>
              <div className="mt-5 flex gap-6 text-sm font-bold text-white/90">
                <div className="flex items-center gap-2"><Smartphone className="w-4 h-4 text-[#F59E0B]"/>Mobile</div>
                <div className="flex items-center gap-2"><Map className="w-4 h-4 text-[#F59E0B]"/>Live GPS</div>
                <div className="flex items-center gap-2"><Calculator className="w-4 h-4 text-[#F59E0B]"/>Accounting</div>
                <div className="flex items-center gap-2"><Bug className="w-4 h-4 text-[#F59E0B]"/>35 Forms</div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-[1024px] text-sm text-slate-600 bg-white rounded-xl p-5 shadow">
          <div className="font-bold text-slate-900 mb-2">How to use this graphic for Google Play</div>
          <ol className="list-decimal pl-5 space-y-1">
            <li>Right-click the graphic above → <b>Save Image As</b> (or use browser dev tools / a screenshot tool for an exact 1024×500 PNG).</li>
            <li>Upload to <b>Play Console → Main store listing → Feature graphic</b>.</li>
            <li>Also export an <b>App icon (512×512)</b> — use the seal logo directly.</li>
          </ol>
        </div>

        {/* 512x512 app icon */}
        <div id="app-icon" className="w-[512px] h-[512px] rounded-3xl flex items-center justify-center shadow-2xl" style={{ background: 'linear-gradient(135deg, #0d2818 0%, #6FA82C 100%)' }}>
          <div className="w-[420px] h-[420px] rounded-3xl bg-white flex items-center justify-center p-4">
            <XpertLogo size={380} variant="seal"/>
          </div>
        </div>
        <div className="max-w-[512px] text-xs text-slate-500">App icon — 512×512. Save and upload as <b>Play Console → App icon</b>.</div>
      </div>
    </div>
  );
}
